import { useQuery } from '@apollo/client'

import { prepareLandingBlocks } from '@entities/LandingPage/model/helpers'
import { GQL_QUERY_LANDING_PAGE } from '@entities/LandingPage/model/queries'
import type {
  LandingPage,
  LandingPageQuery,
  LandingPageQueryVariables,
} from '@entities/LandingPage/model/types'

interface UseLandingPageProps {
  code?: string;
  id?: string;
}

export function useLandingPage ({ code, id }: UseLandingPageProps) {
  const { data, loading, error, refetch } = useQuery<LandingPageQuery, LandingPageQueryVariables>(
    GQL_QUERY_LANDING_PAGE,
    {
      variables: {
        code: code ?? null,
        id: id ?? null,
      },
      fetchPolicy: 'cache-and-network',
      skip: !code && !id,
    },
  )

  const remote = data?.landingPage

  const landingPage: LandingPage | null = remote
    ? {
      ...remote,
      blocks: prepareLandingBlocks(remote.blocks, remote.stateId),
    }
    : null

  return {
    landingPage,
    data,
    loading,
    error,
    refetch,
  }
}
